module.exports = __webpack_public_path__ + "img/20.d0226cbd.jpg";